<template>
  <SensorFormattedDetails :details="details" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { TriggerSummary } from '@/models/sensors-dto'
import SensorFormattedDetails from './SensorFormattedDetails.vue'
import { useStore } from 'vuex-composition-helpers'

const props = defineProps<{
  trigger: TriggerSummary
}>()

const store = useStore()

const scadaUnits = computed(() => {
  return store.state.organizationConfig.scadaUnits
})

const details = computed(() => {
  const { lookahead, threshold, currentVolume, flowRate } = props.trigger

  return [
    {
      label: 'Threshold Value',
      value: threshold ?? '~',
      units: scadaUnits.value,
    },
    {
      label: 'Lookahead Period',
      value: lookahead ?? '~',
      units: 'days',
    },
    {
      label: 'Flow Rate',
      value: flowRate ?? '~',
      units: `${scadaUnits.value}/hr`,
    },
    {
      label: 'Current Volume',
      value: currentVolume ?? '~',
      units: scadaUnits.value,
    },
  ]
})
</script>
